export default{
   banneTitle:'Products',
   navTxt1:'Home',
   navTxt2:'Products',
   listTtile:`Products`,
   listContent:`MIDONKEY has been providing 6 years OEM/ODM services for TOP500 brands at home and abroad. Qualification; quality you can trust us! Even if it exceeds the one-year warranty, we can provide you with the best solution according to your purchase order volume.`,
   itemBtn1:'Quick Inquiry',
   itemBtn2:'View Details',
   itemBtn3:'Contact Us',
   rightBtn:'Reset',
   rightListItem1: "Electric Mountain Bike",
   rightListItem2: "Electric Hybrid Bike",
   rightListItem3: "Electric City Bike",
   rightListItem4: "Electric Bicycle Bike",
   botTxt:'Best Sellers',
   serachTxt:'search for...',
   navTitle1:'Details',
   navTitle2:'Datasheet',
   navTitle3:'FAQs',
}